/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

import Typography from '@material-ui/core/Typography';

import IMAGES from 'constants/images';

import useStyles from './modalSuccess.styles';

const ModalSuccess = React.memo(() => {
  const classes = useStyles();
  return (
    <>
      <Typography className={classes.text} variant='h4'>
        Uma confirmação foi enviada ao seu e-mail. Confirme o cadastro e já pode{' '}
        <span className={classes.textColor}>começar a usar.</span>
      </Typography>
      <img
        alt=''
        src={IMAGES.REGISTER.PLANE}
        style={{
          width: '100%',
          maxWidth: '400px',
          margin: 'auto',
          display: 'block',
        }}
      />
    </>
  );
});

export default ModalSuccess;
export { ModalSuccess };
